/* eslint-disable react/no-unstable-nested-components */
import { AntDesign, Entypo } from '@expo/vector-icons';
import { Divider } from '@mui/material';
import * as React from 'react';
import { FlatList, TouchableOpacity } from 'react-native';
import Modal from 'react-native-modal';
import { keyExtractor } from 'src/common/utils/KeyExtractor';
import { IconButton, RegularText, Row, SwiperHeader } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { device, metrics, pixelScaler } from 'src/themes/Metrics';
import { DropdownType } from 'src/types/types';
import styled from 'styled-components/native';

const Styled = {
  Wrapper: styled.View`
    border-top-left-radius: ${metrics.borderRadius}px;
    border-top-right-radius: ${metrics.borderRadius}px;
    max-height: ${device.height * 0.7}px;
    min-height: ${device.height * 0.4}px;
    padding-top: ${metrics.small}px;
    padding-bottom: ${metrics.large}px;
    background-color: white;
  `,
  //   ItemWrapper: styled(TouchableOpacity)`
  //     border-bottom-width: ${StyleSheet.hairlineWidth}px;
  //     border-color: ${AppColors.border};
  //     height: 56px;
  //     justify-content: center;
  //   `,
};

export const SlideUpModal = ({
  label,
  isVisible,
  data,
  value,
  onClose,
  onPress,
}: {
  label: string;
  isVisible: boolean;
  data?: DropdownType[];
  value?: DropdownType;
  onClose: () => void;
  onPress: (selectedItem: DropdownType) => void;
}) => {
  const renderItem = ({ item }: { item: DropdownType }) => {
    return (
      <TouchableOpacity
        activeOpacity={0.8}
        style={{
          height: pixelScaler(40),
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingHorizontal: metrics.large,
          flexDirection: 'row',
        }}
        onPress={() => {
          onPress(item);
          onClose();
        }}>
        <RegularText>{item.label}</RegularText>
        {value?.value === item.value && <Entypo name="check" size={pixelScaler(20)} color={AppColors.primary} />}
      </TouchableOpacity>
    );
  };

  return (
    <Modal
      style={{ margin: 0, justifyContent: 'flex-end' }}
      animationIn="slideInUp"
      animationOut="slideOutDown"
      onSwipeComplete={onClose}
      hasBackdrop
      onBackButtonPress={onClose}
      onBackdropPress={onClose}
      swipeThreshold={10}
      propagateSwipe
      swipeDirection={['down']}
      isVisible={isVisible}>
      <Styled.Wrapper>
        <SwiperHeader />
        <Row
          paddingHorizontal={metrics.large}
          style={{
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: metrics.large,
          }}>
          <RegularText fontSize="large" fontWeight="bold" textLang={label} />
          <IconButton icon={<AntDesign name="closecircle" size={pixelScaler(28)} />} onPress={onClose} />
        </Row>
        <Divider />

        <FlatList
          ItemSeparatorComponent={() => <Divider />}
          keyExtractor={keyExtractor}
          data={data}
          renderItem={renderItem}
        />
      </Styled.Wrapper>
    </Modal>
  );
};
